import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { FC } from 'react'

type Props = {
  open: boolean
  onCancel: () => void
  onOk: () => void
}

export const TableRowHeadingHideConfirmDialog: FC<Props> = ({
  open,
  onCancel,
  onOk,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>
      見出しを非表示にすると、現在設定されている見出しが破棄されます。非表示にしてよろしいですか？
    </DialogTitle>
    <DialogActions>
      <Button variant="outlined" onClick={onCancel}>
        キャンセル
      </Button>
      <Button variant="contained" onClick={onOk}>
        非表示にする
      </Button>
    </DialogActions>
  </Dialog>
)
